export default "__VITE_ASSET__B6Pue928__"